<template>
	<section class="page-reset-send-success custom-scrollbar">
		<LogoHeader :noSep="true" />
		<p>
			Your password was reset successfuly.You will be redirected to the
			login page shortly.
		</p>
		<router-link
			class="max-width btn btn-primary mt-5"
			:to="{ path: '/console/login' }"
			>Back to Login</router-link
		>
	</section>
</template>

<script>
import LogoHeader from "../shared/LogoHeader";

export default {
	name: "ResetSuccess",
	components: {
		LogoHeader,
	},
	mounted() {
		setTimeout(() => {
			this.$router.push({ path: "/console/login" });
		}, 2000);
	},
};
</script>

<style scoped>

.page-reset-send-success {
	padding: 3em;
	max-width: 30em;
	margin: 0 auto;
}

</style>